import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import user from '../../Mobx/User';

import HomePage from '../Home/HomePage';
import CustomersPage from '../Customers/CustomerPage';
import ClassroomPage from '../Classrooms/ClassroomPage';
import AccessSerialPage from '../AccessSerial/AccessSerialPage';
import PermissionProfilePage from '../PermissionProfile/PermissionProfilePage';
import StatisticsPage from '../Statistics/StatisticsPage';
import DictionaryPage from '../Dictionary/DictionaryPage';
import Login from '../User/Login';
import CategoriesPage from '../Categories/CategoryPage';
import AIPage from '../AI/AIPage';
import ImagesPage from '../Images/ImagesPage';
import SearchBarPage from '../SearchBar/SearchBarPage';
import AudioPage from '../Audio/AudioPage';
import PaymentPage from '../TestPayment/PaymentPage';
import TestsPage from '../Tests/TestsPage';

function Routing() {
    return (
        user.limitedAdmin.includes(user.email) ?
            <Routes>
                <Route path="/" element={<Navigate to="/dictionary" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={<HomePage />} />
                {/* <Route path="/dictionary" element={<DictionaryPage />} />
                <Route path="/categories" element={<CategoriesPage />} /> */}
                <Route path="/ai" element={<AIPage />} />
                <Route path="/images" element={<ImagesPage />} />
                {/* <Route path="/audio" element={<AudioPage />} />
                <Route path="/customers" element={<CustomersPage />} />
                <Route path="/access-serial" element={<AccessSerialPage />} />
                <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/test-paypal" element={<PaymentPage />} /> */}
                {/* Redirect to home if no match found */}
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
            :
            <Routes>
                <Route path="/" element={<Navigate to="/dictionary" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/dictionary" element={<DictionaryPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/ai" element={<AIPage />} />
                <Route path="/tests" element={<TestsPage />} />
                <Route path="/search" element={<SearchBarPage />} />
                <Route path="/images" element={<ImagesPage />} />
                <Route path="/audio" element={<AudioPage />} />
                <Route path="/customers" element={<CustomersPage />} />
                <Route path="/classroom" element={<ClassroomPage />} />
                <Route path="/access-serial" element={<AccessSerialPage />} />
                <Route path="/profiles" element={<PermissionProfilePage />} />
                <Route path="/statistics" element={<StatisticsPage />} />
                <Route path="/test-paypal" element={<PaymentPage />} />
                {/* Redirect to home if no match found */}
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
    );
}

export default Routing;
